import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { loadingReducer } from './reducer';


@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature('loading', loadingReducer),
  ]
})
export class LoadingStoreModule { }
